export default __webpack_public_path__ + "static/logo-46a9535242d3f3f47fff9276c571fecf.webp";